// extracted by mini-css-extract-plugin
module.exports = {"sizzlyColor":"Payment_sizzlyColor__FuKzG","cashPaymentAlignment":"Payment_cashPaymentAlignment__hF2u0","roundedCorners":"Payment_roundedCorners__tWDxO"};